import { render } from "./Disciplinary_Actions.vue?vue&type=template&id=c6fea722"
import script from "./Disciplinary_Actions.vue?vue&type=script&lang=js"
export * from "./Disciplinary_Actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__